// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__E8CeT","verticalAlign":"styles_verticalAlign__pkWnF"};